<template>
  <div class="auth-base d-flex" data-view="auth-base">
    <AuthImg />
    <router-view />
  </div>
</template>

<script>
  import AuthImg from '../../components/forms/auth/AuthImg';
  import setGrooveDisplayStyle from '../../utils/groove-widget';

  export default {
    components: {
      AuthImg,
    },
    beforeMount() {
      setGrooveDisplayStyle('none');
    },
    beforeUnmount() {
      setGrooveDisplayStyle();
    },
  };
</script>

<style lang="scss" scoped>
  @use '../../assets/styles/theme' as *;

  [data-view='auth-base'] {
    background-color: rgb(var(--v-theme-background));
    min-height: 100dvh;
  }
</style>
